import { useLocalForageKey } from '../../../utils/local-storage/useLocalForageKey.hooks'

export type ImpersonationSessionData = {
  pathOrigin: string
}

export const useImpersonationState = () => {
  const { data: impersonationData, setData: setImpersonationData } =
    useLocalForageKey<ImpersonationSessionData>('impersonation')

  return { impersonationData, setImpersonationData }
}
